// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3GwVB","gfeWrapper":"CalendarEvent_gfeWrapper__3gynT"};